module.exports = __webpack_public_path__ + "static/img/1.e6f11b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/1.png
// module id = FF/J
// module chunks = 1